import React from "react";
import { Box, Typography } from "@material-ui/core";
const FoundationDescription = () => (
  <Box>
    <Typography gutterBottom variant="body2">
      Foundational practices focus on creating a team culture, collaborative
      environments, and technical practices.
    </Typography>
    <Typography gutterBottom variant="body2">
      These support fast and iterative journeys through the other parts of the
      loop.
    </Typography>
    <Typography variant="body2">
      Without the foundation, teams cannot reach sustainable, continuous
      delivery.
    </Typography>
  </Box>
);
export default FoundationDescription;
